
const {ccclass, property} = cc._decorator;

//玩家位置信息
export interface SeatConfig
{
    mygold:cc.Vec2;
    small:cc.Vec2;
    goldDir:boolean;
}

@ccclass
export  class K9SeatCfg extends cc.Component {

    @property(cc.Vec2)
    mygold:cc.Vec2 = null;

    @property(cc.Vec2)
    small:cc.Vec2 = null;

    @property(cc.Boolean)
    goldDir:boolean = false;//true left false right

    getPosition(){
        return this.node.position;
    }

    //更新节点位置
    refreshNodeInfo(func:Function){
        if (func) {
            let curConfig:SeatConfig = {
                mygold:this.mygold,
                small:this.small,
                goldDir:this.goldDir,
            };
            func(curConfig);
        }
    }
}
